import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import ProductClassForm from './forms/ProductClassForm';
import ProductClassList from './lists/ProductClassList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {loadComponent} from "../../utils/components";
import Select from "../form/Select";
import Collapse from "../layout/Collapse";
import {Tree} from "../form/tree";
import ComponentConfig from "../form/ComponentConfig";
import PointOfSaleSelectorGrid from "../form/PointOfSale/PointOfSaleSelectorGrid";

class ProductClassSelectSub extends React.Component {

    state = {
        options: [],
        loading: false,
        opened: false
    }

    formatTreeData = (items) => {
        return (items || []).map((item) => {
            item.key = item[this.props.componentConfig.idfield];
            item.label = item.name;
            item.children = this.state.options.filter((category) => category.parent === item.id);
            item.leaf = Array.isArray(item.children) && item.children.length === 0;
            if(item.children) {
                item.children = this.formatTreeData(item.children);
            }
            return item;
        });
    };

    findChild = (category, id) => {
        if (category.id + "" === "" + id) {
            return category;
        }
        return (category.children || []).find((category) => {
            if (category.id + "" === "" + id) {
                return category;
            } else {
                return this.findChild(category);
            }
        });
    }

    componentDidMount() {
        this.loadCategories();
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    loadCategories = async () => {
        await this.promisedSetState({loading: true, options: []});
        const all = await loadComponent("componentlist", {component: this.props.componentConfig.componentname, itemsperpage: 0, view: [this.props.componentConfig.idfield, "name", "parent"]});
        await this.promisedSetState({options: all.items, loading: false});
    }

    render() {
        const selectionMode = this.props.selectionMode ? this.props.selectionMode : (Array.isArray(this.props.value) ? "multiple" : "single");
        let _selectionKeys = Array.isArray(this.props.value) ? this.props.value.map((c) => c instanceof Object && !!c ? c[this.props.componentConfig.idfield] : c).filter((c) => !!c) : (this.props.value instanceof Object && !!this.props.value ? this.props.value[this.props.componentConfig.idfield] : this.props.value);
        _selectionKeys = Array.isArray(_selectionKeys) ? _selectionKeys : [_selectionKeys];
        let selectionKeys = {};
        if (selectionMode === "single") {
            selectionKeys = _selectionKeys[0];
        } else {
            _selectionKeys.map((k) => selectionKeys[k] = true);
        }
        const treeValue = this.formatTreeData((this.state.options || []).filter((c) => !c.parent));
        return <div className="row">
            <div className="col-md-11">
                <Select
                    name={this.props.name}
                    component={this.props.componentConfig.componentname}
                    isMulti={selectionMode !== "single"}
                    objectValue={true}
                    valueKey={"id"}
                    labelKey="name"
                    storeType="remote"
                    saveChanges={this.props.saveChanges}
                    value={this.props.value}
                    {...this.props}
                    label={false}
                />
            </div>
            <div className="col-md-1">
                <Button block={true} color={this.state.opened ? "primary" : "default"} icon={{lib: "fa", name: "tree"}} onClick={() => this.setState({opened: !this.state.opened})}/>
            </div>
            <Collapse collapsed={!!this.state.opened}>
                <div className="col-md-12">
                    <Tree
                        {...this.props}
                        metaKeySelection={false}
                        value={treeValue}
                        selectionMode={selectionMode}
                        onExpand={this.loadOnExpand}
                        selectionKeys={selectionKeys}
                        onSelectionChange={(event) => {
                            if (this.props.disabled || this.state.loading) {
                                return;
                            }
                            if (selectionMode === "multiple") {
                                let values = Object.keys(event.value).filter((key) => event.value[key] !== false).map((key) => event.value[key] === true ? key : event.value[key]);
                                values = this.state.options.filter((c) => values.indexOf(c[this.props.componentConfig.idfield]) !== -1);
                                this.props.saveChanges(this.props.name, values);
                            } else {
                                this.props.saveChanges(
                                    this.props.name,
                                    this.state.options.find((c) => event.value + "" === "" + c[this.props.componentConfig.idfield])
                                );
                            }
                        }}
                        loading={this.state.loading}
                    />
                </div>
            </Collapse>
        </div>;
    }
}

export const ProductClassSelect = (props) => {
    return <ComponentConfig componentName={props.componentName}><ProductClassSelectSub {...props} /></ComponentConfig>;
}

class ProductClassEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Kategóriák"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <ProductClassList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Kategória"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <ProductClassForm {...this.props} />
                </Editor>
                <Other>
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <PointOfSaleSelectorGrid
                        componentConfig={this.props.componentConfig}
                        name="pos"
                        data={this.props.values}
                        {...this.props.getFieldProps("pos")}
                    />
                }
                </Other>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "ProductClass", WrappedComponent: ProductClassEditor, props: {view: "admin"}});
